import React from 'react'
import './Cards.css';
import CardItem from './CardItem'

function Cards() {
  return (
    <div className='cards'>

        <h1>Some of our featured designs</h1>
        <div class="cards__container">
            <div className='cards__wrapper'>
                <ul className='cards__items'>
                    <CardItem
                        src='images/mandir1.jpeg'
                        text='Extra Large Mandiram design for Priest'
                        label='Mandiram'
                        path='/'                    
                    />
                    <CardItem
                        src='images/mandir2.jpeg'
                        text='Jade Linga after Pooja'
                        label='Idol'
                        path='/'                    
                    />
                </ul>
                <ul className='cards__items'>
                    <CardItem
                        src='images/mandir3.jpeg'
                        text='Preparation for Sahasra Lingaarchana'
                        label='Pooja'
                        path='/'                    
                    />
                    <CardItem
                        src='images/mandir4.jpg'
                        text='Regular Sized Mandiram'
                        label='Mandiram'
                        path='/'                    
                    />
                    <CardItem
                        src='images/JMSLogo.png'
                        text='Logo for the website'
                        label='Logo'
                        path='/'                    
                    />
                </ul>
            </div>

        </div>

    </div>
  )
}

export default Cards